import QuoteMark from "@/assets/svg/advisor-inner/quote-mark.svg?react"

interface AdvisorQuoteProps {
  photo: string
  quote: string
}

/** Advisor avatar + speech bubble with a signature quote. Ported from AdvisorsInner Quote. */
export function AdvisorQuote({ photo, quote }: AdvisorQuoteProps) {
  return (
    <div data-slot="advisor-quote" className="mt-4 flex items-end gap-3">
      <div className="flex size-13 min-w-13 items-center justify-center rounded-full bg-gradient-to-br from-peach to-purple-accent">
        <img
          src={photo}
          alt="advisor"
          className="size-12 rounded-full border-4 border-dark-base object-cover"
        />
      </div>

      <div className="relative">
        <span className="absolute -bottom-[5px] -left-1.5 w-3.5 [&_svg]:w-3.5">
          <QuoteMark />
        </span>
        <div className="rounded-2xl bg-[#221c32] px-4 py-3 text-purple-light">
          <p className="font-display text-base font-medium">{`“${quote}”`}</p>
        </div>
      </div>
    </div>
  )
}
